import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { ApplicationService } from '../../../../services/application.service.js';
import { style } from './job.style.js';
import { globalStyle } from '../../../../global-styles.style.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiPersonalJobComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepJob');
    this.values = {};
    this.coAppPrefix = '';
    this.jobId = '';
  }

  static styles = [style, globalStyle];

  static properties = {
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
  };

  connectedCallback() {
    super.connectedCallback();
    this.coAppPrefix = this.isPrimary ? '' : 'co-';
    this.jobId = `${this.coAppPrefix}jobDescription`;
    this.application = ApplicationService.Application;
    this.PQV2 = ApplicationService.isIconicV2;
    this.values.jobDescription = this.isPrimary
      ? this.application.primaryApplicant.employmentInfo.jobDescription
      : this.application.coApplicant.employmentInfo.jobDescription;
  }

  // https://github.com/cypress-io/cypress/issues/311, to test it we had added {3,} to the regex. this duplicates over the built in logic but will catch simulated events.
  render() {
    return html`
      <div class="personal__jobDescription">
        <fs-text-field
          id="${this.jobId}"
          name="jobDescription"
          type="text"
          value-missing-message="Please enter a valid job title"
          maxLength="50"
          minLength="3"
          autocomplete
          pattern="(([ \\-.']*)?[A-Za-z]+([ \\-.']*)?)*.{3,}"
          required
          @change="${(ev) => {
            this.changed('jobDescription', ev);
          }}"
          @blur="${(ev) => {
            if (ev.target.validity.valid && !this.PQV2) {
              stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
                replacements: { value: this.jobId },
              });
            } else if (!ev.target.validity.valid && !this.PQV2) {
              stratum.publishTag(
                TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
                {
                  replacements: {
                    value:
                      'Please enter at least 3 characters and no special characters',
                  },
                }
              );
            }
          }}"
          value="${this.values.jobDescription}"
          pattern-mismatch-message="Please enter at least 3 characters and no special characters"
          autofocus
        >
          Job title
        </fs-text-field>
      </div>
    `;
  }

  resetValues() {
    this.application = ApplicationService.Application;
    this.values.jobDescription = this.isPrimary
      ? this.application.primaryApplicant.employmentInfo.jobDescription
      : this.application.coApplicant.employmentInfo.jobDescription;

    const jobField = this.shadowRoot.getElementById(this.jobId);
    jobField.setAttribute('value', this.values.jobDescription);

    this.requestUpdate();
  }

  changed(name, ev) {
    if (ev.target.validity.valid) {
      this.values[name] = ev.target.value.trim();
    }
    if (this.PQV2) {
      stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
        replacements: { value: this.jobId },
      });
    }
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: { name, isValid: ev.target.validity.valid },
      })
    );
  }
}

customElements.define('refi-personal-job', RefiPersonalJobComponent);
